export const routes = {
  sidebarRoutes: [
    {
      name: "Home",
      path: "/",
    },
    {
      name: "About us",
      path: "/about-us",
    },
    {
      name: "Careers",
      path: "/Careers",
    },
    {
      name: "Contact us",
      path: "/contact-us",
    },
  ],
};

export default routes;
